import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { applicationIdSelector, buildServerSelector } from '../../reducers/selectors';

const {
  REACT_APP_PROVISIONAL_OFFER_ENDPOINT_REDIRECT: PROVISIONAL_OFFER_ENDPOINT_REDIRECT,
  REACT_APP_PLATFORM_REDIRECT: PLATFORM_REDIRECT,
} = process.env;

const redirectUrl = (applicationId, borrowerStatus) => {
  if (borrowerStatus === 'Provisional Offer') {
    return `${PROVISIONAL_OFFER_ENDPOINT_REDIRECT}`.replace('{applicationId}', applicationId);
  }
  return `${PLATFORM_REDIRECT}`.replace('{applicationId}', applicationId);
};

const SuccessPage = ({ applicationId, builder }) => {
  const { borrowerStatus } = builder;
  useEffect(() => {
    window.location.href = redirectUrl(applicationId, borrowerStatus);
  });

  return (
    <div className="container container--space-y">
      <header>
        <h1>Processing request</h1>
      </header>
      Please wait while we redirect you...
    </div>
  );
};

SuccessPage.propTypes = {
  applicationId: PropTypes.string.isRequired,
  builder: PropTypes.shape({
    borrowerStatus: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  applicationId: applicationIdSelector(state),
  builder: buildServerSelector(state),
});

export { SuccessPage, mapStateToProps };

export default connect(mapStateToProps, null)(SuccessPage);
